import * as React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
} from "react-admin";

/*
{
  "locale": "en-US",
  "name": "Warehouse #1",
  "desc": "description",
  "phone": "+66891234567|TH",
  "email": "anonymous@xyz.com",
  "address": "123 Pearl Building, Aree, Bangkok",
  "status": "Active",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
}
*/

export const LocationCreate = (props) => (
  <>
    <Typography variant="h3" style={{ marginTop: 20 }}>
      Create Location
    </Typography>
    <Create {...props}>
      <SimpleForm>
        <Box>
          <TextInput source="name" />

          <TextInput multiline source="desc" />
          <TextInput source="phone" />
          <TextInput source="email" type="email" />

          <TextInput source="address" />
          <TextInput source="status" initialValue="Active" disabled />

          <ImageInput label="Related pictures" accept="image/*" source="image">
            <ImageField source="src" title="title" />
          </ImageInput>
        </Box>
      </SimpleForm>
    </Create>
  </>
);
